import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/pages/faq.module.scss';
import { Layout } from 'components/organisms/layout';
import { ContentsTitle } from 'components/molecules';
import { Faq as FaqComponent } from 'components/organisms';

import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';

export const Faq: React.FC = () => {
  return (
    <Layout>
      <div className={styles.faqPageWrapper}>
        <ContentsTitle className={styles.contentsTitle} title="FAQ" subTitle="よくある質問" />
        <div className={styles.content}>
          <FaqComponent />
        </div>
        <Link className={styles.topLink} to="/">
          <BlackCircleArrow className={styles.navButton} />トップページへ戻る
        </Link>
      </div>
    </Layout>
  );
};
